var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 17,
    height: 17,
    transform: "translate(0.226)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(-0.226)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1.226 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M9.143,1.143a7.951,7.951,0,0,0-8,8,7.951,7.951,0,0,0,8,8,7.951,7.951,0,0,0,8-8A7.951,7.951,0,0,0,9.143,1.143ZM9.143,16A6.857,6.857,0,1,1,16,9.143,6.877,6.877,0,0,1,9.143,16Z",
    transform: "translate(-1.143 -1.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M12.229,13.143,9.143,10.057,6.057,13.143l-.914-.914L8.229,9.143,5.143,6.057l.914-.914L9.143,8.229l3.086-3.086.914.914L10.057,9.143l3.086,3.086Z",
    transform: "translate(-1.143 -1.143)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.86d548bdce5ca773c284bae4d5239181.svg";
export { ForwardRef as ReactComponent };